<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Latest CTC Details Report</h5>
  </div>
  <div class="container" id="mainContent">
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Branch<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedBranch" #designateBranch="ngModel">
                  <mat-option (click)="selectAllBranch(designateBranch, branchList)" [value]="0">Select All
                  </mat-option>
                  <mat-option (click)="getPartnerByBranch()" #item *ngFor="let branch of branchList" [value]="branch">
                    {{ branch.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Reporting Partner<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedPartner" #designatePartner="ngModel">
                  <mat-option (click)="selectAllPartner(designatePartner, partnerList)" [value]="0">Select All
                  </mat-option>
                  <mat-option #item *ngFor="let partner of partnerList" [value]="partner">
                    {{ partner.firstName }} {{partner.middleName}} {{ partner.lastName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-sm-2">
          <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onViewReport()">
            View Report
          </button>
        </div>
        <div class="col-sm-2" *ngIf="showExportToExcelButton">
          <button (click)="excelExportCtcDetailsReport()" class="btn btn-sm btn-block btn-outline-theme">
            <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container" id="mainContent">
    <div class="pt-2" *ngIf="latestCtcDetailsReport != null">
      <div class="row mt-2 justify-content-center text-center">
        <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>
      <div class="row mt-2 justify-content-center text-center">
        <span class="bg-theme-title">Latest CTC Details Report</span>
      </div>
      &nbsp;&nbsp;
      <ng-container *ngFor="let data of latestCtcDetailsReport">

        <div class="row" *ngFor="let p of data.partner">

          <div class="col-sm-8">
            <label class="col-form-label">
              <b>Reporting Partner :</b>
              {{ p.partnerFName }} {{ p.partnerLName }}
            </label>
          </div>

          <div class="col-sm-4">
            <label class="col-form-label">
              <b>Branch :</b>
              {{ data.branch }}
            </label>
          </div>

          <div class="table-responsive" style="overflow-x:auto; margin-bottom:30px;">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Service Vertical</th>
                  <th>Joining Date</th>
                  <th>CTC From Date</th>
                  <th>CTC To Date</th>
                  <th>CTC</th>
                  <th>Basic</th>
                  <th>HRA</th>
                  <th>Conveyance Allowance</th>
                  <th>Other Allowance</th>
                  <th>Variable Component %</th>
                  <th>Variable Component</th>
                  <th>Provident Fund (ER)</th>
                  <th>ESIC (ER)</th>
                  <th>Exgratia Month</th>
                  <th>Exgratia</th>
                  <th>Prof. Exception Month</th>
                  <th>Prof. Exception Tax</th>
                  <th>Prof Tax</th>
                  <th>Security Deposit</th>
                  <th>Security From Date</th>
                  <th>Security To Date</th>
                  <th>Loan</th>
                  <th>Loan From Date</th>
                  <th>Loan To Date</th>
                  <th>EMI</th>
                  <th>Advance Month</th>
                  <th>Advance</th>
                  <th>Recovery Month</th>
                  <th>Recovery/Expenses</th>
                  <th>OT Status</th>
                  <th>Gratuity</th>
                  <th>Training and Welfare</th>
                  <th>Laptop Eligibility</th>
                  <th>Laptop Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let detail of p.latestCtcDetails; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ detail.name }}</td>
                  <td>{{ detail.designation }}</td>
                  <td>{{ detail.serviceVertical }}</td>
                  <td>{{ detail.joiningDate | date:'dd-MM-yyyy' }}</td> 
                  <td>{{ detail.ctcFromDate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ detail.ctcToDate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ detail.ctc }}</td>
                  <td>{{ detail.basic }}</td>
                  <td>{{ detail.hra }}</td>
                  <td>{{ detail.conveyanceAllowance }}</td>
                  <td>{{ detail.otherAllowance }}</td>
                  <td>{{ detail.variableComponentPercent }}</td>
                  <td>{{ detail.variableComponent }}</td>
                  <td>{{ detail.providentFund }}</td>
                  <td>{{ detail.esic }}</td>
                  <td>{{ detail.exgratiaMonth }}</td>
                  <td>{{ detail.exgratia }}</td>
                  <td>{{ detail.professionalExceptionMonth }}</td>
                  <td>{{ detail.professionalExceptionTax }}</td>
                  <td>{{ detail.professionalTax }}</td>
                  <td>{{ detail.securityDeposit }}</td>
                  <td>{{ detail.securityFromDate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ detail.securityToDate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ detail.loan }}</td>
                  <td>{{ detail.loanFromDate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ detail.loanToDate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ detail.emi }}</td>
                  <td>{{ detail.advanceMonth }}</td>
                  <td>{{ detail.advance }}</td>
                  <td>{{ detail.recoveryMonth }}</td>
                  <td>{{ detail.recoveryOrExpenses }}</td>
                  <td>{{ detail.overtimeStatus }}</td>
                  <td>{{ detail.gratuity }}</td>
                  <td>{{ detail.traningAndWelfare }}</td>
                  <td>{{ detail.laptopEligibility }}</td>
                  <td>{{ detail.laptopAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        
      </ng-container>
    </div>
  </div>
</div>